export const ItemTypes = {
  DOCUMENT: 'DOCUMENT',
  FOLDER: 'FOLDER',
};
